import * as t from 'io-ts';

import { Decoding } from '@catawiki/runtime-toolkit';

import { BiddingCurrency } from './money';

export const User = t.type({
  id: t.number,
  bidder_token: t.string,
  bidding_currency: t.type({
    code: BiddingCurrency,
    symbol: t.string,
  }),
  user_name: t.string,
  country: t.type({
    short_code: Decoding.nullable(t.string),
    in_eea: t.boolean,
  }),
  email: t.string,
});
export type User = t.TypeOf<typeof User>;

export const Me = t.type({
  user: User,
});
export type Me = t.TypeOf<typeof Me>;

export const FavoriteId = t.type({
  lot_id: t.number,
  id: t.number,
});
export type FavoriteId = t.TypeOf<typeof FavoriteId>;

export const UserFavoritesResponse = t.type({
  favorites: t.array(FavoriteId),
});
export type UserFavoritesResponse = t.TypeOf<typeof UserFavoritesResponse>;
